import type { CapabilityMap } from './types';

/**
 * 平台能力注册表：模块级 Map，启动时由装配清单（`apps.ts`）
 * import 各 app 的 `capabilities.tsx` 完成注册，运行期只读。
 * 查不到 = 该能力未装配，消费方收起对应入口（不是报错）。
 */

const registered = new Map<string, unknown>();

/** 注册一项能力（启动期调用；重复注册保留首个，保证幂等）。 */
export function registerCapability<K extends keyof CapabilityMap>(
  key: K,
  capability: CapabilityMap[K],
): void {
  if (!registered.has(key)) registered.set(key, capability);
}

/** 查询一项能力；未装配返回 undefined。 */
export function getCapability<K extends keyof CapabilityMap>(
  key: K,
): CapabilityMap[K] | undefined {
  return registered.get(key) as CapabilityMap[K] | undefined;
}
